import { Button, Dialog, HStack, Input, Portal, Stack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Field } from "../ui/field";
import { useDispatch, useSelector } from "react-redux";
import { addNewAddress } from "../../Redux/Action";
import { getUserIP } from "../../Utils/newHelper";

export const AddressForm = ({
  isAddressDialogOpen,
  setIsAddressDialogOpen,
}) => {
  const userData = useSelector((state) => state?.Login?.userData);
  const [IP, setIP] = useState("");
  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    phone: "",
    house: "",
    street: "",
    region: "",
    city: "",
    postcode: "",
    state: "",
    country: "",
  });
  const [errors, setErrors] = useState({
    fname: "",
    lname: "",
    phone: "",
    house: "",
    street: "",
    region: "",
    city: "",
    postcode: "",
    state: "",
    country: "",
  });
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchIP = async () => {
      const ip = await getUserIP();
      setIP(ip);
    };

    fetchIP();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;
    const newErrors = {};

    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = "This field is required";
        hasError = true;
      }
    });

    setErrors(newErrors);

    if (!hasError) {
      formData.email = userData?.email;
      formData.ip = IP;
      setIsAddressDialogOpen(false);
      dispatch(
        addNewAddress({
          submit:"address",
          payload: formData,
          callback: (data) => {
          },
        })
      );
    }
  };

  return (
    <Dialog.Root
      size="xs"
      placement="center"
      motionPreset="scale"
      open={isAddressDialogOpen}
      onOpenChange={(e) => setIsAddressDialogOpen(e.open)}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header textAlign="center">
              <Dialog.Title>Add New Address</Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>
            <Dialog.Body>
              <Stack
                gap="4"
                align="center"
                maxW="sm"
                margin="auto"
                borderRadius="10px"
              >
                <HStack>
                  <Field
                    label="First name"
                    invalid={!!errors.fname}
                    errorText={errors.fname}
                  >
                    <Input
                      name="fname"
                      value={formData.fname}
                      onChange={handleChange}
                    />
                  </Field>
                  <Field
                    label="Last name"
                    invalid={!!errors.lname}
                    errorText={errors.lname}
                  >
                    <Input
                      name="lname"
                      value={formData.lname}
                      onChange={handleChange}
                    />
                  </Field>
                </HStack>
                <HStack>
                  <Field
                    label="Mobile No."
                    invalid={!!errors.phone}
                    errorText={errors.phone}
                  >
                    <Input
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </Field>
                  <Field
                    label="House No."
                    invalid={!!errors.house}
                    errorText={errors.house}
                  >
                    <Input
                      name="house"
                      value={formData.house}
                      onChange={handleChange}
                    />
                  </Field>
                </HStack>
                <Field
                  label="Street"
                  invalid={!!errors.street}
                  errorText={errors.street}
                >
                  <Input
                    name="street"
                    value={formData.street}
                    onChange={handleChange}
                  />
                </Field>
                <Field
                  label="Region"
                  invalid={!!errors.region}
                  errorText={errors.region}
                >
                  <Input
                    name="region"
                    value={formData.region}
                    onChange={handleChange}
                  />
                </Field>
                <HStack>
                  <Field
                    label="City"
                    invalid={!!errors.city}
                    errorText={errors.city}
                  >
                    <Input
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                    />
                  </Field>
                  <Field
                    label="Postcode"
                    invalid={!!errors.postcode}
                    errorText={errors.postcode}
                  >
                    <Input
                      name="postcode"
                      value={formData.postcode}
                      onChange={handleChange}
                    />
                  </Field>
                </HStack>
                <HStack>
                  <Field
                    label="State"
                    invalid={!!errors.state}
                    errorText={errors.state}
                  >
                    <Input
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                    />
                  </Field>
                  <Field
                    label="Country"
                    invalid={!!errors.country}
                    errorText={errors.country}
                  >
                    <Input
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                    />
                  </Field>
                </HStack>
              </Stack>
            </Dialog.Body>
            <Dialog.Footer justifyContent="center">
              <Button variant="surface" type="submit" onClick={handleSubmit}>
                Submit
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
